/**
 * @description Module HP edito Slider
 */

/* global drupalSettings */

((root = 'slider-edito-container', slidePerView = { lg: 1, md: 1, sm: 1 }) => {
	// VARS
	const sliderEdito = document.querySelector('.slider-edito-container');
	const slideTab = drupalSettings.yellowstone.homepage_highlight;
	const $ = {
		root: root,
		slider: `data-slider`,
		slide: `slider-edito__slide`,
		dots: `nav__pagination`,
		dot: `slide-edito-dot`,
		next: 'nav__arrow__next',
		prev: 'nav__arrow__prev',
		play: 'nav__autoplay',
		skip: 'data-skip-slider',
		end: 'data-end-slider',
	};

	let thisSlide = 0;
	let maxSlide;
	let breakpoint;

	const bsBreakpoint = window.innerWidth;

	if (bsBreakpoint >= 1200) {
		breakpoint = 'lg';
	} else if (bsBreakpoint > 767 && bsBreakpoint < 1200) {
		breakpoint = 'md';
	} else {
		breakpoint = 'sm';
	}

	// FONCTIONS
	const sliderBuild = () => {
		/**
		 * @description slide sans miniature
		 *
		 */

		let itemsResult = `<ul class="slider-edito">`;
		let bannerImg;

		for (let i = 0; i < slideTab.length; i++) {
			bannerImg = slideTab[i].img;
			itemsResult += `
          <li class="slider-edito__slide" style="background-image:url('${bannerImg}');" data-slide="${i}" tabindex="0">
            <div class="hp-edito__highlight__overlay">
							<div class="hp-edito__highlight__overlay__content">
							<h3>${slideTab[i].title}</h3>
							<a  class="btn btn-primary slider-edito__slide__btn stretched-link" href="${slideTab[i].uri}">
								${slideTab[i].button}
								 <span class="sr-only">${slideTab[i].title}</span>
							</a>
              </div>
            </div>
          </li>`;
		}
		itemsResult += `</ul>`;
		sliderEdito.insertAdjacentHTML('afterbegin', itemsResult);
	};

	/**
	 * @description A11Y du slider
	 * @param thisSlide {number}
	 * @constructor
	 */
	const A11Y = (thisSlide) => {
		const nbSlide = SlidePerView();
		const sliderEnd = thisSlide + nbSlide;

		document
			.querySelectorAll(`.${$.root} .${$.slide}`)
			.forEach((item, index) => {
				if (index >= thisSlide && index < sliderEnd) {
					item.tabIndex = 0;
				} else {
					item.tabIndex = -1;
				}
			});

		document
			.querySelectorAll(`.${$.root} .${$.slide}[tabindex='0'] a`)
			.forEach((link) => {
				link.tabIndex = 0;
			});

		document
			.querySelectorAll(`.${$.root} .${$.slide}[tabindex='-1'] a`)
			.forEach((link) => {
				link.tabIndex = -1;
			});
	};

	const focusSlide = () => {
		setTimeout(() => {
			document
				.querySelector(`.${$.root} .${$.slide}[tabindex='0'] a`)
				.focus();
		}, 330);
	};

	/**
	 * @description Fonction pour skip le slider
	 */
	const skipSlider = () => {
		document
			.querySelector(`.${$.root} [${$.skip}]`)
			.addEventListener('click', () => {
				document.querySelector(`.${$.root} [${$.end}]`).focus();
			});
	};

	/**
	 * @description Renvoie le numéro de slide actuel su slider
	 * @returns {number}
	 * @constructor
	 */
	const ThisSlide = () => {
		const activeDot = document.querySelector(`.${$.root} .${$.dot}.active`);
		let value;
		const hasValue = activeDot || null;

		if (hasValue) {
			value = activeDot.getAttribute('data-nb-slide');
		} else {
			value = 0;
		}

		return Number(value);
	};

	/**
	 * @description Renvoie le nombre de pixel du translate pour le slider
	 * @returns {string}
	 */
	const translateSlide = () => {
		const widthSlide = document.querySelector(
			`.${$.root} .${$.slide}`
		).scrollWidth;
		const translate = widthSlide * thisSlide;

		return `${translate}`;
	};

	/**
	 * @description Renvoie le nombre de slide par vue celon le breakpoint
	 * @returns {number}
	 * @constructor
	 */
	const SlidePerView = () => {
		return slidePerView[breakpoint];
	};

	/**
	 * @description Return le nombre de slide présent dans le slider
	 * @returns {number}
	 * @constructor
	 */
	const MaxSlide = () => {
		return document.querySelectorAll(`.${$.root} .${$.slide}`).length;
	};

	/**
	 * @description Action à effectuer au click sur btn next//prev
	 * @param btn {string}
	 * @param clickDot {number}
	 *
	 */
	const nav = (btn = 'next', clickDot = null) => {
		thisSlide = ThisSlide();

		if (clickDot || clickDot === 0) {
			thisSlide = clickDot;
		} else {
			if (btn === 'next') {
				if (thisSlide < maxSlide - 1) {
					thisSlide = thisSlide + 1;
				} else {
					thisSlide = 0;
				}
			} else {
				if (thisSlide > 0) {
					thisSlide = thisSlide - 1;
				} else {
					thisSlide = maxSlide - 1;
				}
			}
		}
		const translate = translateSlide();

		document
			.querySelectorAll(`.${$.root} .${$.slide}`)
			.forEach((item, index) => {
				item.style.transform = `translateX(-${translate}px)`;

				if (index < thisSlide) {
					item.style.opacity = '0';
					item.style.visibility = 'hidden';
				} else {
					item.style.visibility = 'inherit';
					item.style.opacity = '1';
				}
			});

		document.querySelectorAll(`.${$.root} .${$.dot}`).forEach((dot) => {
			if (dot.classList.contains('active')) {
				dot.classList.remove('active');
				dot.removeAttribute('aria-current');
			}
			if (dot.getAttribute('data-nb-slide') === thisSlide.toString()) {
				dot.classList.add('active');
				dot.setAttribute('aria-current', 'true');
			}
		});
		A11Y(thisSlide);
		applyData();
	};

	/**
	 * @description Action au click sur un dot
	 * @constructordocument
					.querySelector(`.${$.root} [${$.end}]`)
					.focus();

	 */
	const ClickDot = () => {
		document.querySelectorAll(`.${$.root} .${$.dot}`).forEach((dot) => {
			dot.addEventListener('click', () => {
				const thisDot = Number(dot.getAttribute('data-nb-slide'));

				nav('next', thisDot);
				focusSlide();
			});
		});
	};

	/**
	 * @description Mise en écoute des btn next//prev
	 */
	const navSlide = () => {
		maxSlide = MaxSlide();

		if (slideTab.length <= 1) {
			document
				.querySelector('.slider-edito__next-box')
				.classList.add('none');
		} else if (slideTab.length >= 2) {
			document
				.querySelector('.slider-edito__next-box')
				.classList.remove('none');
		}

		if (MaxSlide() === 1) {
			document.querySelector('.slider-edito__nav').style.display = 'none';
		}

		document
			.querySelector(`.${$.root} .${$.next}`)
			.addEventListener('click', () => {
				nav('next');
				focusSlide();
			});

		document
			.querySelector(`.${$.root} .${$.prev}`)
			.addEventListener('click', () => {
				nav('prev');
				focusSlide();
			});

		ClickDot();
	};

	/**
	 * @description Conception des dotdot
	 */
	const dotDot = () => {
		maxSlide = MaxSlide();

		const nbPerView = SlidePerView();
		const nbDot = maxSlide - nbPerView + 1;
		let content = ``;

		document.querySelector(`.${$.root} .${$.dots}`).innerHTML = '';

		if (maxSlide > nbPerView) {
			for (let i = 1; i <= nbDot; i++) {
				content += `<button class="slide-edito-dot${
					i === 1 ? ` active` : ''
				}" data-nb-slide="${
					i - 1
				}" aria-current="true" aria-describedby="actuTitle">
					<span class="sr-only">${i === 1 ? 'diapositive ' : ''}${i}</span>
				</button>`;
			}
		}

		document
			.querySelector(`.${$.root} .${$.dots}`)
			.insertAdjacentHTML('afterbegin', content);
	};

	const autoPlay = (delay = 5000) => {
		const play = document.querySelector(`.${$.root} .${$.play}`);
		let playCarousel;
		let isPaused = false;

		if (play.dataset.sliderPlay === 'true') {
			playCarousel = setInterval(() => {
				document
					.querySelectorAll(`.${$.root} .custom-slider__slide__btn`)
					.forEach((element) => {
						if (document.activeElement === element) {
							isPaused = true;
						}

						element.addEventListener('focusout', () => {
							isPaused = false;
						});
					});
				if (!isPaused) {
					nav('next');
				}
			}, delay);
		} else {
			clearInterval(playCarousel);
		}

		play.addEventListener('click', () => {
			if (play.dataset.sliderPlay === 'true') {
				play.dataset.sliderPlay = 'false';
				play.innerHTML = 'Lire';
				clearInterval(playCarousel);
			} else {
				playCarousel = setInterval(() => {
					nav('next');
				}, delay);
				play.dataset.sliderPlay = 'true';
				play.innerHTML = 'Pause';
			}
		});
	};

	const applyData = () => {
		const miniature =
			document.querySelector('.slider-edito__next-box') || null;

		const hasBullet =
			sliderEdito.querySelector('.slide-edito-dot.active div') || null;
		const hasCurrentSlide =
			sliderEdito.querySelector('.current-slide') || null;

		if (miniature) {
			const miniatureTitle = miniature.querySelector('h3') || null;
			if (!miniatureTitle) {
				miniature
					.querySelector('.slider-edito__next-box__content > div')
					.insertAdjacentHTML('beforeend', '<h3></h3>');
			}
			const nextSlide =
				Number(
					document
						.querySelector(`.${$.root} .${$.slide}[tabindex="0"]`)
						.getAttribute('data-slide')
				) + 1;

			const nextData = slideTab[nextSlide];

			if (nextData) {
				miniature
					.querySelector('.slider-edito__next-box__img')
					.setAttribute(
						'style',
						`background-image:url('${nextData.thumbnail}');`
					);
				miniature.querySelector('h3').textContent = nextData.title;
			} else {
				miniature
					.querySelector('.slider-edito__next-box__img')
					.setAttribute(
						'style',
						`background-image:url('${slideTab[0].thumbnail}');`
					);
				miniature.querySelector('h3').textContent = slideTab[0].title;
			}

			const currentIndex = Number(
				sliderEdito
					.querySelector(`.${$.root} .${$.slide}[tabindex="0"]`)
					.getAttribute('data-slide')
			);

			sliderEdito
				.querySelectorAll('.slide-edito-dot div')
				.forEach((bar) => {
					if (bar.getAttribute('data-bullet') < currentIndex) {
						bar.classList.remove('slider-progressbar--animation');
						bar.classList.add('slider-progressbar--full');
					} else {
						bar.classList.remove('slider-progressbar--animation');
						bar.classList.remove('slider-progressbar--full');
					}
				});

			if (hasBullet) {
				sliderEdito
					.querySelector('.slide-edito-dot.active div')
					.classList.remove('slider-progressbar--full');

				sliderEdito
					.querySelector('.slide-edito-dot.active div')
					.classList.add('slider-progressbar--animation');
			}

			if (hasCurrentSlide) {
				sliderEdito.querySelector('.current-slide').textContent =
					('0' + Number(currentIndex + 1)).slice(-2) +
					' / ' +
					('0' + Number(slideTab.length)).slice(-2);
			}
		}
	};

	const paginationAnimation = () => {
		let i = 0;
		sliderEdito.querySelectorAll('.slide-edito-dot').forEach((bar) => {
			bar.insertAdjacentHTML(
				'afterbegin',
				`<span data-bullet="${i}"></span>`
			);
			i++;
		});
	};

	// Stop le slider si on focus une slide
	const stopSlider = () => {
		document.addEventListener('keyup', (e) => {
			if (e.key === 'Tab' || e.key === 'Enter') {
				if (
					document.activeElement ===
					document.querySelector(
						`.${$.root} .${$.slide} a[tabindex='0']`
					)
				) {
					document.querySelector(`.${$.root} .${$.play}`).click();
				}
			}
		});
	};

	// GO 🚀
	const init = () => {
		if (sliderEdito) {
			sliderBuild();
			dotDot();
			A11Y(thisSlide);
			skipSlider();
			navSlide();
			autoPlay();
			paginationAnimation();
			applyData();
			stopSlider();
		}
	};

	init();
})();
